import React, { useState, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Breadcrumbs from "../../Navigation/Components/Breadcrumbs";
import Button from "react-bootstrap/Button";
import axios from "axios";
import { useTranslation } from "react-i18next";
import "./NewAccountForm.css";

function NewAccountForm() {
  const [name, setName] = useState("");

  const navigate = useNavigate();

  const { state } = useContext(AuthContext);

  const { t } = useTranslation();

  const handleSubmit = async () => {
    try {
      await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/accounts`,
        data: {
          name: name,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate("/accounts");
    } catch (error) {
      console.log(error.response.data);
    }
  };

  const handleNameChange = (evt) => {
    setName(evt.target.value);
  };

  let breadcrumbs = [
    {
      title: "Cuentas",
      path: "/accounts",
    },
  ];

  return (
    <Container fluid>
      <Row>
        <Breadcrumbs data={breadcrumbs} />
      </Row>
      <Row>
        <Col className="new-account-header">
          <h2>{t("Cuentas.Cuenta.NewForm.Titulo")}</h2>
        </Col>
      </Row>
      <Row>
        <Col className="new-account-form">
          <Form>
            <FloatingLabel
              controlId="floatingInput"
              label="Nombre de la cuenta"
              className="mb-3"
            >
              <Form.Control
                type="text"
                placeholder="nombre de la cuenta"
                onChange={handleNameChange}
              />
            </FloatingLabel>
            <Button className="primary" onClick={handleSubmit}>
              {t("Cuentas.Cuenta.NewForm.Guardar")}
            </Button>
            <Link to="/accounts">
              <Button className="danger">
                {t("Cuentas.Cuenta.NewForm.Cancelar")}
              </Button>
            </Link>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}

export default NewAccountForm;
